import { gql } from 'apollo-boost';

export const UPDATE_USER_FILE_SIZE = gql`
    mutation($data: UpdateUserFileSizeInput!) {
        updateUserFileSize(data: $data)
    }
`;

